<template>
  <div class="address-form">
    <form ref="form" @submit.prevent="sendAddress">
      <div class="grid-row">
        <div class="c-6 c-xs-12 c-md-12 c-lg-12">
          <div class="form-field">
            <label>{{$_('last_name_delivery')}}</label>
            <Input :type="'text'" class="form-element" :maxlength="25" @typing="form_data.TNOM = $event.toUpperCase()" :val="form_data.TNOM" />
          </div>
          <div class="form-field">
            <label>{{$_('address_2')}}</label>
            <Input :type="'text'" class="form-element" :maxlength="25" @typing="form_data.TADR2 = $event.toUpperCase()" :val="form_data.TADR2" />
          </div>
          <div class="form-field">
            <label>{{$_('address_3')}}</label>
            <Input :type="'text'" class="form-element" :maxlength="25" @typing="form_data.TADR3 = $event.toUpperCase()" :val="form_data.TADR3"  />
          </div>
          <div class="grid-row code-field">
            <div class="c-2 c-xs-12 c-md-12 c-lg-12">
              <div class="form-field">
                <label>{{$_('postal_code')}}</label>
                <Input :type="'text'" class="form-element" :maxlength="10" @typing="form_data.TCPOST = $event.toUpperCase()" :val="form_data.TCPOST" />
              </div>
            </div>
            <div class="c-4 c-xs-12 c-md-12 c-lg-12">
                <div class="form-field">
                  <label>{{$_('city')}}</label>
                  <Input :type="'text'" class="form-element" :maxlength="30" @typing="form_data.TVILLE = $event.toUpperCase()" :val="form_data.TVILLE" />
                </div>
            </div>
          </div>
          <div class="form-field">
            <label>{{$_('country')}}</label>
            <Select
                :placeholder="$_('your_choice')"
                :itemoption="['TCPAYS', 'TLIB_PAYS']"
                :data="form_info.country"
                :search="true"
                :preselected="form_data.TCPAYS"
                @select-change="setCountryAndLoadDistrict($event.item)"
            />
          </div>
          <div class="form-field">
            <label>{{$_('district')}}</label>
            <Select
                :placeholder="$_('your_choice')"
                :itemoption="['TCPROV', 'TLIB_PROV']"
                :data="form_info.district"
                :search="true"
                :preselected="form_data.TCPROV"
                @select-change="form_data.TCPROV = $event.item"
            />
          </div>
        </div>
        <div class="c-6 c-xs-12 c-md-12 c-lg-12">
          <div class="form-field">
            <label>{{$_('address')}}</label>
            <Input :type="'text'" class="form-element" :maxlength="25" @typing="form_data.TADR1 = $event.toUpperCase()" :val="form_data.TADR1" />
          </div>

          <div class="form-field">
            <label>{{$_('tel_number')}}</label>
            <Input type="tel" class="form-element" maxlength="10" @typing="form_data.TTEL = $event.toUpperCase()" :val="form_data.TTEL" />
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>

import Select from '@/common/components/widget/Select'
import SwitchInput from '@/common/components/widget/Switch/SwitchInput'
import Input from '@/common/components/widget/Input/Input'

import customerService from '@/modules/client/services/customerService';

export default {
  name: "AddressForm",
  props: {
    form_type: {
      type: String,
      default: ''
    },
    validate: {
      type: Boolean,
      default: false
    },
    form: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    Select,
    SwitchInput,
    Input
  },
  data() {
    return {
      form_data: {
        TTYP_ADR: 'L',
        TNLIG: '',
        TNOM: '',
        TADR1: '',
        TADR2: '',
        TADR3: '',
        TCPOST: '',
        TVILLE: '',
        TCPAYS: '',
        TCPROV: '',
        TTEL: '',
        TADR_DEFAUT: 'N',
        TTOP_ADR: 'A',
      },
      form_info: {
        country: Array(),
        district: Array()
      }
    }
  },
  created() {

    switch(this.$props.form_type) {
      case 'add':
        this.form_data.TTOP_ADR = 'A';
        break;
      case 'update':
        this.form_data.TTOP_ADR = 'M'
        break;
    }

    customerService.getCountry().then(res => {
      this.form_info.country = res.data.DS_O.OUT;
    });

    if (this.$props.form !== undefined) {
      Object.entries(this.$props.form).map(arr => {
        if(arr[0] !== 'TLPAYS' && arr[0] !== 'TLPROV') {
          this.form_data[arr[0]] = arr[1];
        }
      })
    }
  },
  methods: {
    sendAddress() {
      this.$store.dispatch('client/SET', {key: 'address', value: []});

      customerService.sendCustomerAddress(this.form_data)
      .then(res => {
        if(res.data !== undefined && res.data.POK === 1) {
          this.$emit('complete');

          customerService.getCustomerAddress('account')
          .then(res => {
            if(res.data.DS_O !== undefined) {
              this.$store.dispatch('client/SET', {key: 'address', value: res.data.DS_O.OUT});
            }
          })
        }
      })
    },
    setCountryAndLoadDistrict(country_code) {

      this.form_data.TCPAYS = country_code;

      customerService.getDistrict(country_code).then(res => {
        this.form_info.district = res.data.DS_O.OUT;
      });
    }
  },
  computed: {
    getValidate() {
      return this.$props.validate;
    }
  },
  watch: {
    getValidate(val) {
      if(val) {
        this.sendAddress();
      }
    }
  },
};
</script>

<style scoped>
form {
  width: 100%;
}
.grid-row.code-field {
  margin: -15px;
}
/deep/
.select-box {
  margin: 0;
}
/deep/
input {
  width: 100%;
  text-transform: uppercase;
}
</style>
